import { Component, OnInit,ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BankAccountsService} from 'app/shared/services/bank-accounts.service';
import { AuthService } from 'app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  selector: 'app-bank-accounts',
  templateUrl: './bank-accounts.component.html',
  styleUrls: ['./bank-accounts.component.css']
})
export class BankAccountsComponent implements OnInit {

  displayedColumns: string[] = ['accountName','bank','accountNo','currentBal','createdBy','action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  data : any[];  

  bankAccount : any;
  readOnlyField :boolean = false;
  bankAccountForm: FormGroup;
  showProcessingIndicator = false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  validationMessages = {
    'accountName': { 'required': 'Account Name is required' },
    'bank': { 'required': 'Bank Name is required' }, 
  };

  formErrors = {
    'accountName': "",
    'bank': "",
  };


  constructor(private fb: FormBuilder,
              private bankAccountsService:BankAccountsService,
              private toastr: ToastrService,
              private dialogService: DialogService,
              private authService: AuthService,
              private router : Router, 
              public dialogRef: MatDialogRef<BankAccountsComponent>
            ) { }

  ngOnInit(): void {

    this.bankAccount = {
      accountName : '',
      bank : '',
      accountNo : '',
      openingBal : '',
      openingBalDate : '',
      createdBy : '',
    }
    this.initializeForm();
    this.getDataTableRowData();
    this.getControlPermissions();

  } //nd oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='MACC'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }


  initializeForm(){
    this.bankAccountForm = this.fb.group({
      id : [null],  
      accountName : ['', Validators.required],   
      bank : ['',Validators.required],  
      accountNo : [''],  
      openingBal : [''],  
      openingBalDate : [''],  
   
    });

  }

  onClose(){
    this.bankAccountForm.reset();
    this.dialogRef.close();
   }

  clearButtonClick(): void {    
    this.bankAccountForm.reset();
    this.resetValiationErrors();
    this.readOnlyField = false;
  }

  saveButtonClick(): void {

    this.logValidationErrors(this.bankAccountForm, true);
    this.mapFormValuesToModel();

    if (this.isFilledFromFields()) {

      if (!this.bankAccountForm.value.id) {
        this.showProcessingIndicator = true;
        this.bankAccountsService.addBankAccount(this.bankAccount)
          .subscribe(
            (res) => {

              if(res.success === 0){
                this.toastr.error(res.message, 'warning');
                this.showProcessingIndicator = false;
              }else if(res.success === 1){
                this.toastr.success('Bank Account added successfully', 'Success');                           
                this.bankAccountForm.reset();
                this.resetValiationErrors();
                this.onClose();
                this.showProcessingIndicator = false;
               
              }
                         
            },
            (err) => {
              this.toastr.error('Failed to add Bank Account', 'Failure');
              this.showProcessingIndicator = false;
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
          )

        }else{
          this.showProcessingIndicator = true;
        this.bankAccountsService.update(this.bankAccount)
          .subscribe(
            (res) => {
                this.toastr.success('Updated successfully', 'Success');                           
                this.bankAccountForm.reset();
                this.resetValiationErrors();
                this.onClose();
                this.showProcessingIndicator = false;
                          
                         
            },
            (err) => {
              this.toastr.error('Failed to update record', 'Failure');
              this.showProcessingIndicator = false;
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
          )



        }
      } else {  
        
          this.toastr.warning('Required Fields cannot be empty or invalid.', 'Error Message');
          this.showProcessingIndicator = false;
    }


  }


  enableForm(): void {
    Object.keys(this.bankAccountForm.controls).forEach(key => {
      this.bankAccountForm.controls[key].enable();
    });
  }


  disableForm(): void {
    Object.keys(this.bankAccountForm.controls).forEach(key => {
      this.bankAccountForm.controls[key].disable();
    });
  }

  resetValiationErrors(){
    Object.keys(this.bankAccountForm.controls).forEach(key => {
      this.bankAccountForm.get(key).setErrors(null) ;
    });
  }

  logValidationErrors(group: FormGroup = this.bankAccountForm, isDirty: boolean = false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (isDirty) {
        this.enableForm();
        this.bankAccountForm.controls[key].markAsTouched();
      }
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }


  isFilledFromFields(): boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
        return false;
    }
    return true;
  }

  mapFormValuesToModel() {
    this.bankAccount.accountName= this.bankAccountForm.value.accountName;
    this.bankAccount.bank= this.bankAccountForm.value.bank;
    this.bankAccount.accountNo= this.bankAccountForm.value.accountNo;
    this.bankAccount.openingBal= this.bankAccountForm.value.openingBal;
    this.bankAccount.openingBalDate= this.bankAccountForm.value.openingBalDate ?  moment(this.bankAccountForm.value.openingBalDate).format("YYYY-MM-DD") : null;
    this.bankAccount.createdBy = this.authService.getUserLoggedIn();

  }

  viewTransaction(data:any){

    this.bankAccountForm.patchValue({  
      id     :data.Id,
      accountName     :data.AccountName,
      bank   :data.Bank,
      accountNo   :data.AccountNo,
      openingBal   :data.OpeningBal,
      openingBalDate   :moment(data.OpeningBalDate).format("YYYY-MM-DD") || null,
     
    })
  
  
  
  }
  
  getDataTableRowData(){
    var data = this.bankAccountsService.dataRow;
    if(data){
      this.viewTransaction(data);
     // this.isSaveBtnDisabled= true;
     this.readOnlyField = true;
    }
    else{
      this.clearButtonClick();
    }
  
  }
  


}
